<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>

<div class="container">
    <div class="row">
        <div class="col-sm-6">
            <h1 class="title-default">Categoria Arquivo</h1>
        </div>
        <div class="col-sm-6">
            <a type="button" mat-button class="btn-primary btn-add-right" routerLink="/desenvolvedor/categoria-arquivo/cadastrar" *appTemPermissao="_PermissaoEnum.Desenvolvedor_CategoriaArquivo_Incluir"
            >
                <mat-icon>add</mat-icon>
                Nova Categoria
            </a>
        </div>
    </div> 
    <form class="form" [formGroup]="model"  (ngSubmit)="clickPesquisar()" class="search-area">
        <div class="row">
            <div class="col-md-6">
                <mat-form-field appearance="outline">
                    <mat-label>Nome</mat-label>
                    <input matInput formControlName="nomePesquisa" type="text">
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <button type="submit" mat-button class="btn-secundary" style="width: 140px;">
                    Pesquisar
                </button>
            </div>
        </div>
    </form>

    @if(this._listaCategoriaArquivoResponse && this._listaCategoriaArquivoResponse.listaCategoriaArquivo){
        <table mat-table [dataSource]="_dataSource">
            <ng-container matColumnDef="idCategoriaArquivo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> # </th>
                <td mat-cell *matCellDef="let element"> {{element.idCategoriaArquivo}} </td>
            </ng-container>

            <ng-container matColumnDef="nome">
              <th mat-header-cell *matHeaderCellDef> Nome </th>
              <td mat-cell *matCellDef="let element"> {{element.nome}} </td>
            </ng-container>

             <ng-container matColumnDef="observacao">
                <th mat-header-cell *matHeaderCellDef> Observação </th>
                <td mat-cell *matCellDef="let element"> {{element.observacao}} </td>
            </ng-container>

            <ng-container matColumnDef="action-edit">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element"> 
                    <a mat-mini-fab aria-label="Editar" class="fab-action default" [routerLink]="['/desenvolvedor/categoria-arquivo/cadastrar',
                    {idCategoriaArquivo: element.idCategoriaArquivo}]" *appTemPermissao="_PermissaoEnum.Desenvolvedor_CategoriaArquivo_Alterar">
                        <mat-icon>edit</mat-icon>
                    </a>
                </td>
            </ng-container> 

             <ng-container matColumnDef="action-delete">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element"> 
                    <button type="button" mat-mini-fab aria-label="Excluir" class="fab-action default" (click)="abrirModalExcluir(element.idCategoriaArquivo, element.nome)" *appTemPermissao="_PermissaoEnum.Desenvolvedor_CategoriaArquivo_Excluir">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>       

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div class="col-12 text-center ver-mais-pesquisa">
            <button type="button" mat-button class="btn-primary" [disabled]="_ultimaPagina" (click)="proximaPagina()">
                @if (_isLoading === true) {
                    <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
                @else{
                    <span class="material-symbols-outlined">keyboard_arrow_down</span>
                    Ver mais
                }
            </button>
        </div>
    }@else if(_isLoading === true){
        <table>
            @for (item of [1,2,3]; track item) {
                <tr>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'110'" [marginTop]="'30'"></app-loading-box>
                    </td>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'220'" [marginTop]="'30'" [marginLeft]="'50'"></app-loading-box>
                    </td>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'320'" [marginTop]="'30'"  [marginLeft]="'50'"></app-loading-box>
                    </td>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'40'" [marginTop]="'30'"  [marginLeft]="'100'"></app-loading-box>
                    </td>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'40'" [marginTop]="'30'"  [marginLeft]="'20'"></app-loading-box>
                    </td>
                </tr>
            }
            
        </table>
    }
    @else if(this._listaCategoriaArquivoResponse?.listaCategoriaArquivo){
        <app-empty-list [title]="'Não foi encontrado nenhuma categoria com o filtro informado'"></app-empty-list>
    }
    

    
</div>
